export const appendImageCacheBust = (
  url: string,
  version: string | number = Date.now(),
): string => {
  if (!url || url.startsWith('data:') || url.startsWith('blob:')) return url;

  const [base, query = ''] = url.split('?');
  const params = new URLSearchParams(query);
  params.set('v', String(version));

  return `${base}?${params.toString()}`;
};
